export default {
    price: 4000,
    hasCustomBackground: true,
    light: {
        primary: '#5F6264',
        secondary: '#A85817',
        accent: '#82B1FF',
    },
    dark: {
        primary: '#8D9296',
        secondary: '#A85817',
        accent: '#82B1FF',
    }
}
